// extracted by mini-css-extract-plugin
export var active = "_6f-a";
export var activeIndicator = "_6f-9";
export var disabled = "_6f-b";
export var fullWidth = "_6f-2";
export var lg = "_6f-7";
export var md = "_6f-6";
export var redoButtonTabGroup = "_6f-0";
export var sm = "_6f-5";
export var tabButton = "_6f-4";
export var tabButtonsContainer = "_6f-1";
export var themeDestructive = "_6f-d";
export var themeNormal = "_6f-c";
export var themeSuccess = "_6f-e";
export var xl = "_6f-8";
export var xs = "_6f-3";